import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateConfigurationPrivacy } from '../actions'
import {
    Button,
    Card
} from '@chakra-ui/react'
import Editor from '../components/Editor'
import { getConfig } from '../reducers'

const ConfigurationPrivacy = () => {

    const [html, setHTML] = useState("")
    const [mounted, setMounted] = useState(false)
    const [editorSetted, setEditorSetted] = useState(false)
    const [editor, setEditor] = useState(null)
    const dispatch = useDispatch()

    const config = useSelector(state => getConfig(state))

    useEffect(() => {
        setHTML( config.privacy === null ? '' : config.privacy)
        setMounted(true)
    }, [])

    const saveConfigurationPrivacy = () => {
        const form = { privacy : html}
        dispatch(updateConfigurationPrivacy(form))
    }

    return (
        <div>
            <legend>Contenido de Aviso de privacidad </legend>
            <br/>
            <Card>
                {mounted ?
                    <Editor placeholder={"Contenido"} setHTML={setHTML} setEditor={setEditor} initialHtml={html} setEditorSetted={setEditorSetted} editorSetted={editorSetted} />
                    : <>Loading</>
                }
            </Card>

            <Button colorScheme="teal" variant="outline" onClick={saveConfigurationPrivacy} mt={4}>
                Actualizar
            </Button>
        </div>
    )

}

export default ConfigurationPrivacy